import
  React
from 'react';

import
  styled
from 'styled-components';

import {
  PropTypes
} from 'prop-types';

import {
  ColorSvg,
  HContainerV,
  Text,
  VContainer
} from '@vodacom/web-common';

import {
  CustomColors,
  Icons
} from '../../constants';

const Container = styled(VContainer)`
  border-bottom: ${props => props.borderBottom};
`;

export const ActionCardList = props => {

  const createList = () => {

    let list = [];

    for (const item of props.items) {

      list.push(

        <VContainer
          key={`action-card-list-item-${item.text}`}
          onClick={item.onClick}>

          <HContainerV
            padding={'12px 0 0'}>

            <Text
              fontSize={props.textFontSize}
              fontWeight={props.textFontWeight}
              fontFamily={props.fontFamily}
              color={CustomColors.Grey9}
              width={'95%'}
              padding={props.cardPadding}>

              {item.text}

            </Text>

            <ColorSvg
              src={Icons.Chevron}
              color={CustomColors.Grey9}
              height={'19px'}
              width={'19px'}
              margin={'0 0 0 auto'}/>

          </HContainerV>

          <Container
            borderBottom={`1px solid ${props.dividerColor}`}>

            {
              <Text
                fontSize={props.subtextFontSize}
                fontFamily={props.fontFamily}
                color={props.subtextFontColor}
                fontWeight={props.subtextFontWeight}
                padding={'0 0 10px'}>

                {item.subText}

              </Text>
            }
          </Container>

        </VContainer>
      );
    }

    return list;

  };

  return (

      <VContainer
        width={'100%'}
        backgroundColor={props.backgroundColor}
        boxSizing={'border-box'}
        padding={'10px'} >

        <Text
          fontSize={'20px'}
          fontWeight={'bold'}
          fontFamily={props.fontFamily}
          color={props.titleColor}
          padding={props.headerPadding}>

          {props.title}
        </Text>

        { props.items?.length > 0 ?

          createList()

          : props.fallbackComponent
        }

      </VContainer>

  );
};

ActionCardList.propTypes = {
  items: PropTypes.array,
  title: PropTypes.string,
  titleColor: PropTypes.string,
  textFontSize: PropTypes.string,
  textFontWeight: PropTypes.string,
  subtextFontSize: PropTypes.string,
  subtextFontWeight: PropTypes.string,
  subtextFontColor: PropTypes.string,
  backgroundColor: PropTypes.string,
  headerPadding: PropTypes.string,
  dividerColor: PropTypes.string,
  cardPadding: PropTypes.string,
  fontFamily: PropTypes.string,
  fallbackComponent: PropTypes.element
};

ActionCardList.defaultProps = {
  title: 'Title',
  titleColor: CustomColors.Grey11,
  items: null,
  textFontSize: '14px',
  textFontWeight: 'bold',
  subtextFontSize: '14px',
  subtextFontWeight: '300',
  subtextFontColor: CustomColors.Grey7,
  backgroundColor: CustomColors.Transparent,
  headerPadding: '18px 0 8px',
  dividerColor: CustomColors.Grey5,
  cardPadding: '0px',
  fontFamily: 'Roboto',
  fallbackComponent: null
};